module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      " + _vm._s(_vm.selectedKontakte.length) + " " + _vm._s(_vm.bezMitglieder) + " bearbeiten\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-alert', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("Diese Funktion ist bisher noch nicht für verschiedene Vereine optimiert. Daher kann sie nur für Ripuaria\n            verwendet werden.")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          Sollen alle Kontakte oder nur die ausgeählten Kontakte bearbeitet werden?\n          "), _c('v-radio-group', {
    model: {
      value: (_vm.bearbeiteteFelder.alleBearbeiten),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "alleBearbeiten", $$v)
      },
      expression: "bearbeiteteFelder.alleBearbeiten"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Alle Bearbeiten",
      "value": "true",
      "on-icon": "radio_button_checked",
      "off-icon": "radio_button_unchecked"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Ausgewählte Bearbeiten",
      "value": "false",
      "on-icon": "radio_button_checked",
      "off-icon": "radio_button_unchecked"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsAnrede,
      "label": "Anrede"
    },
    model: {
      value: (_vm.bearbeiteteFelder.anrede),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "anrede", $$v)
      },
      expression: "bearbeiteteFelder.anrede"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsBriefanrede,
      "label": "Briefanrede"
    },
    model: {
      value: (_vm.bearbeiteteFelder.briefanrede),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "briefanrede", $$v)
      },
      expression: "bearbeiteteFelder.briefanrede"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.selectVerbindung,
      "label": "Urverbindung"
    },
    model: {
      value: (_vm.bearbeiteteFelder.urverbindung),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "urverbindung", $$v)
      },
      expression: "bearbeiteteFelder.urverbindung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "feld",
    attrs: {
      "hide-details": "auto",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "items": _vm.itemsZirkel,
      "label": "AH-Zirkel"
    },
    model: {
      value: (_vm.bearbeiteteFelder.zirkel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "zirkel", $$v)
      },
      expression: "bearbeiteteFelder.zirkel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "items": _vm.itemsStatus,
      "label": "Status"
    },
    model: {
      value: (_vm.bearbeiteteFelder.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "status", $$v)
      },
      expression: "bearbeiteteFelder.status"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Aktiven-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.aktivenBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "aktivenBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.aktivenBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "CV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.cvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "cvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.cvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "AHV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.ahvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "ahvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.ahvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "HBV-Beitrag"
    },
    model: {
      value: (_vm.bearbeiteteFelder.hbvBeitrag),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "hbvBeitrag", $$v)
      },
      expression: "bearbeiteteFelder.hbvBeitrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-2"
  }, [_vm._v("\n              SEPA Berechtigungen ändern?\n              "), _c('v-spacer'), _vm._v(" "), _c('v-switch', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.bearbeiteteFelder.sepa_bearbeiten),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "sepa_bearbeiten", $$v)
      },
      expression: "bearbeiteteFelder.sepa_bearbeiten"
    }
  })], 1), _vm._v(" "), (_vm.bearbeiteteFelder.sepa_bearbeiten) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.bearbeiteteFelder.sepa_bearbeiten) ? _c('v-card-text', _vm._l((_vm.kassen), function(item, index) {
    return _c('v-switch', {
      key: index,
      attrs: {
        "outlined": "",
        "label": item.name
      },
      model: {
        value: (_vm.bearbeiteteFelder.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.bearbeiteteFelder.sepa, item.name, $$v)
        },
        expression: "bearbeiteteFelder.sepa[item.name]"
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateData()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.showUpdate),
      callback: function($$v) {
        _vm.showUpdate = $$v
      },
      expression: "showUpdate"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [_vm._v(" Kontakte updaten ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-progress-linear', {
    attrs: {
      "stream": "",
      "rounded": "",
      "height": "24",
      "value": (_vm.updatedItems / _vm.allItems) * 100
    }
  }, [_vm._v("\n          " + _vm._s(_vm.updatedItems) + " von " + _vm._s(_vm.allItems) + "\n        ")]), _vm._v(" "), (_vm.error.length > 0) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdate = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c30736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogKontaktEditMultiple.vue
// module id = 765
// module chunks = 15